import { KYMW6100Component } from './kymw6100.component';

/**
 * EC画像指示一覧表画面の値を管理するクラス
 *
 * @export KYMW6100Model
 * @class KYMW6100Model
 */
export class KYMW6100Model {

  KYMW6100Component: KYMW6100Component;

  /** ファイル名 */
  public fileName: string = <string>'';
  /** 出力区分 */
  public radioGroup: string = <string>'';
  /** 受注コード */
  public orderCode: string = <string>'';
  /** 画像ファイル名リスト */
  public fileNameList: string = <string>'';
  // 項番2231 START 障害管理No.U01061対応
  // /** 受注コード活性非活性判定 */
  // public disabledorderCodeToFlg: boolean = <boolean>false;
  // /** 画像ファイル名リスト活性非活性判定 */
  // public disabledFileNameListToFlg: boolean = <boolean>true;
  // 項番2231 END 障害管理No.U01061対応

  /**
  * ファイル名を更新する
  *
  * @param serverData ファイル名のサーバ取得データ
  */
  public updateFileName(serverData: any) {
    this.fileName = serverData.fileName;
  }
}
